import React from 'react';
import { pencilIcon } from '@chordbaker/design';

interface PencilIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const PencilIcon: React.FC<PencilIconProps> = ({
  className,
  size = 12,
  color = 'currentColor'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={pencilIcon.viewBox}
      fill={pencilIcon.fill}
      stroke={color}
      strokeWidth={pencilIcon.strokeWidth}
      strokeLinecap={pencilIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
      strokeLinejoin={pencilIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
      className={className}
    >
      <path d={(pencilIcon.elements[0] as { d: string }).d} />
    </svg>
  );
};

export default PencilIcon;
